var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"buttonM",class:_vm.color,domProps:{"innerHTML":_vm._s(_vm.btnTxt)}})
}
var staticRenderFns = []

export { render, staticRenderFns }